import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

import {
  DESKTOP_VISIBLE_CARDS,
  SLIDE_GAP,
  TABLET_VISIBLE_CARDS,
} from "./constants";

const slideFlexBasis = (visibleCards: number) =>
  `0 0 calc(100% / ${visibleCards})`;

export const Root = styled(Box)(() => ({
  position: "relative",
  width: "100%",

  "&:hover .CardsCarouselArrow": {
    opacity: 1,
  },
}));

export const Viewport = styled(Box)(() => ({
  overflow: "hidden",
}));

export const Container = styled(Box)(() => ({
  display: "flex",
  marginLeft: -SLIDE_GAP,
}));

export const Slide = styled(Box)(({ theme }) => ({
  flex: slideFlexBasis(DESKTOP_VISIBLE_CARDS),
  minWidth: 0,
  paddingLeft: SLIDE_GAP,
  [theme.breakpoints.between("md", "lg")]: {
    flex: slideFlexBasis(TABLET_VISIBLE_CARDS),
  },
  [theme.breakpoints.down("sm")]: {
    flex: "0 0 82%",
  },
}));

export const ScrollArrow = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: "50%",
  zIndex: 2,
  width: "20px",
  height: "20px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  color: theme.palette.text.primary,
  backgroundColor: theme.palette.background.paper,
  border: `1px solid ${theme.palette.grey.A400}`,
  borderRadius: "20px",
  cursor: "pointer",
  opacity: 0,
  transform: "translateY(-50%)",
  transition: theme.transitions.create("opacity", {
    duration: theme.transitions.duration.shorter,
  }),

  "@media (hover: none)": {
    opacity: 1,
  },

  "&:focus-visible": {
    opacity: 1,
  },

  "& svg": {
    width: "15px",
    height: "15px",
  },

  "&.left": {
    left: 0,
  },

  "&.right": {
    right: 0,
  },
}));
